import { Helmet, HelmetProvider } from 'react-helmet-async';

export default function BDHelmet({ title, description = '' }) {
	const bzTitle = import.meta.env.VITE_TITLE_APP;

	let contentTitle = `${bzTitle}`;
	if (title) {
		contentTitle = `${title} | ${bzTitle}`;
    }

	return (
		<HelmetProvider>
			<Helmet>
				<title>{contentTitle}</title>
				<meta name="description" content={description} />
			</Helmet>
		</HelmetProvider>
	);
}
